'use client';

import type { FC } from 'react';
import { Modal, ModalContent } from '@paypoteam/ui-components';

import { LocalImage } from '@/components/atoms/LocalImage';

import type {
    InfoModalContentType,
    ModalFooterProps,
} from '../RegistrationForm.types';

export interface InfoModalProps {
    modalContent: InfoModalContentType;
    isVisible: boolean;
    handleClose: () => void;
}

const InfoModal: FC<InfoModalProps> = ({
    modalContent,
    isVisible,
    handleClose,
}) => {
    const { title, buttonsProps, withIcon, dataTestId } = modalContent;

    const DEFAULT_BUTTONS_CONFIG = {
        config: [
            {
                size: 'm',
                children: 'Zamknij',
                onClick: () => handleClose(),
                variant: 'outline',
                ...(dataTestId && {
                    'data-testid': `${dataTestId}-button-cancel`,
                }),
            },
        ],
        className: 'justify-end',
    } as ModalFooterProps;

    return (
        <Modal
            open={isVisible}
            onOpenChange={handleClose}
        >
            <ModalContent
                buttonsFactoryProps={buttonsProps || DEFAULT_BUTTONS_CONFIG}
                title={title}
            >
                {withIcon && (
                    <LocalImage
                        src="/images/animations/registration-man.gif"
                        alt="Obrazek informujący o błędzie weryfikacji"
                        height={135}
                        width={100}
                    />
                )}
            </ModalContent>
        </Modal>
    );
};

export default InfoModal;
